import React from 'react';
import {
  Box,
  Container,
  Typography,
  AppBar,
  Toolbar,
  Link,
  Button,
  IconButton,
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsOfServicePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Terms of Service
          </Typography>
          <Link component={RouterLink} to="/support" color="inherit" sx={{ mr: 2 }}>
            Support
          </Link>
          <Link component={RouterLink} to="/privacy" color="inherit">
            Privacy Policy
          </Link>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1" paragraph>
          By accessing and using ChessWiz, you accept and agree to be bound by the terms 
          and provision of this agreement. If you do not agree to abide by the above, 
          please do not use this service.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          2. Use License
        </Typography>
        <Typography variant="body1" paragraph>
          Permission is granted to temporarily download one copy of ChessWiz for personal, 
          non-commercial transitory viewing only. This is the grant of a license, not a 
          transfer of title, and under this license you may not modify or copy the materials.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          3. Disclaimer
        </Typography>
        <Typography variant="body1" paragraph>
          The materials on ChessWiz are provided on an 'as is' basis. ChessWiz makes no 
          warranties, expressed or implied, and hereby disclaims and negates all other 
          warranties including without limitation, implied warranties or conditions of 
          merchantability, fitness for a particular purpose, or non-infringement of 
          intellectual property or other violation of rights.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          4. Limitations
        </Typography>
        <Typography variant="body1" paragraph>
          In no event shall ChessWiz or its suppliers be liable for any damages (including, 
          without limitation, damages for loss of data or profit, or due to business 
          interruption) arising out of the use or inability to use the materials on ChessWiz.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          5. Accuracy of Materials
        </Typography>
        <Typography variant="body1" paragraph>
          The materials appearing on ChessWiz could include technical, typographical, or 
          photographic errors. ChessWiz does not warrant that any of the materials on its 
          website are accurate, complete or current.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom sx={{ mt: 3 }}>
          6. Contact Information
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms of Service, please contact us at 
          legal@chesswiz.net.
        </Typography>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/')}
          >
            Back to Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage;
